module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.showEnvelopeComplete) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader__icon"
  })]) : [_c('app-header', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('modal', {
    attrs: {
      "header": _vm.$t('header'),
      "isInitiallyActive": _vm.allowTour,
      "isLarge": "true"
    },
    scopedSlots: _vm._u([{
      key: "modalButtons",
      fn: function(props) {
        return [_c('app-button', {
          attrs: {
            "text": _vm.showModalButtons ? _vm.$t('functional.noThanks') : _vm.$t('functional.close'),
            "iconName": "times",
            "action": props.close
          }
        }), _vm._v(" "), (_vm.showModalButtons) ? _c('app-button', {
          attrs: {
            "text": _vm.$t('functional.showMe'),
            "iconName": "chevron-right",
            "action": _vm.showSlideShow,
            "classList": "float-right button--cta"
          }
        }) : _vm._e()]
      }
    }], null, false, 1437293898)
  }, [_c('envelope-guide')], 1)]], 2) : _c('div', [_c('envelope-complete', {
    attrs: {
      "status": _vm.envelopeStatus,
      "clientId": _vm.clientId,
      "companyName": _vm.companyName,
      "requestedEnvelope": _vm.requestedEnvelope
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232a192c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1045
// module chunks = 1